import type { MantineColorScheme } from '@mantine/core';

/** `--app-surface` as hex, for colour maths that can't read a CSS variable. */
export const SURFACE_HEX: Record<Exclude<MantineColorScheme, 'auto'>, string> = {
	light: '#ffffff',
	dark: '#242424',
};

/** The browser bar colour (`<meta name="theme-color">`) for each scheme. */
export const BROWSER_BAR_HEX: Record<Exclude<MantineColorScheme, 'auto'>, string> = {
	light: '#0f172a',
	dark: '#1a1a1a',
};
